var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "email_svg__svg-safari-fix",
  viewBox: "0 0 34 34",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M23.8 10.2H10.2c-.935 0-1.691.765-1.691 1.7L8.5 22.1c0 .935.765 1.7 1.7 1.7h13.6c.935 0 1.7-.765 1.7-1.7V11.9c0-.935-.765-1.7-1.7-1.7m0 3.4L17 17.85l-6.8-4.25v-1.7l6.8 4.25 6.8-4.25z"
})));
export default SvgEmail;